import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircle, Phone, Calendar, Waves, ArrowRight } from "lucide-react";
import { HOW_IT_WORKS } from "../data/site";
import FinalCTA from "../components/FinalCTA";

const icons = [MessageCircle, Phone, Calendar, Waves];

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page">
      <section className="aqua-section pb-0">
        <div className="aqua-container max-w-3xl">
          <p className="text-eyebrow">How It Works</p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold mt-3 text-[#0B2F6B] leading-tight">
            A simple process, from first hello to first lesson.
          </h1>
          <p className="mt-5 text-[#3B5878] text-base sm:text-lg leading-relaxed">
            No confusing menus. No pushy sales. Just a friendly path that gets
            your child (or you!) safely into the water with a coach who knows
            what they're doing.
          </p>
        </div>
      </section>

      <section className="aqua-section">
        <div className="aqua-container">
          <div className="relative">
            <div className="absolute left-6 sm:left-8 top-4 bottom-4 w-px bg-[#DCE7F5] hidden sm:block" />
            <div className="space-y-8">
              {HOW_IT_WORKS.map((step, i) => {
                const Icon = icons[i] || Waves;
                return (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: i * 0.1 }}
                    className="relative flex gap-6 sm:gap-8"
                    data-testid={`how-step-${i}`}
                  >
                    <div
                      className="w-12 h-12 sm:w-16 sm:h-16 rounded-2xl flex items-center justify-center flex-shrink-0 text-white relative z-10"
                      style={{ backgroundColor: "#1E7BE0" }}
                    >
                      <Icon className="w-5 h-5 sm:w-7 sm:h-7" />
                    </div>
                    <div className="flex-1 card-soft p-6 sm:p-7">
                      <div className="flex items-baseline gap-3">
                        <span className="font-heading text-sm font-bold text-[#33BED6]">STEP {step.step}</span>
                        <h3 className="font-heading text-xl sm:text-2xl font-semibold text-[#0B2F6B]">{step.title}</h3>
                      </div>
                      <p className="mt-3 text-[#3B5878] leading-relaxed">{step.description}</p>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>

          <div className="mt-16 rounded-3xl p-8 sm:p-12 text-center" style={{ backgroundColor: "#EAF3FF" }}>
            <p className="text-eyebrow">Pricing</p>
            <h2 className="font-heading text-3xl sm:text-4xl font-semibold mt-3 text-[#0B2F6B]">
              Custom pricing for your family.
            </h2>
            <p className="mt-4 text-[#3B5878] max-w-2xl mx-auto leading-relaxed">
              Because every situation is a little different — age, program,
              session length, location — we share pricing one-on-one after we
              learn about your needs. Reach out and we'll get you a quick,
              honest quote.
            </p>
            <Link to="/contact" data-testid="request-pricing-cta" className="btn-primary mt-7">
              Request Pricing <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
